import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { MutationConfig } from 'lib/react-query';
import queryKeys from './queryKeys';

interface DeletePayload {
  id: number;
}

interface DeleteResponse {
  success: boolean;
}

export const deleteQuery = async ({
                                    id,
                                  }: DeletePayload): Promise<DeleteResponse> => {
  const res = await apiClient.delete<DeleteResponse>(
    `${queryKeys.creativeTexts}/${id}`,
  );
  return res.data;
};

type MutationFnType = (data: DeletePayload) => ReturnType<typeof deleteQuery>;

interface UseDeleteOptions {
  config?: MutationConfig<MutationFnType>;
}

export const useDeleteCreativeText = ({ config }: UseDeleteOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    onSuccess: async (...args) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [queryKeys.creativeTexts],
        }),
        queryClient.invalidateQueries({
          queryKey: [queryKeys.flows],
        }),
      ]);

      if (config?.onSuccess) {
        await config.onSuccess(...args);
      }
    },
    onError: (...args) => {
      if (config?.onError) {
        config.onError(...args);
      }
    },
    mutationFn: deleteQuery,
  });
};
